module.exports = __webpack_public_path__ + "img/vol06_character_img03_sp.6f5419a2.png";